const TabButtonsStyle = `
  display: flex;
  grid-column-gap: 15px;
  margin-bottom: 10px;
  flex-wrap: wrap;
  grid-row-gap: 5px;
`;

export default TabButtonsStyle;
